import { styled } from "@mui/material"

export const Counter = styled("span")({
	background: "#CBB78B",
	width: "2rem",
	height: "2rem",
	display: "grid",
	placeItems: "center",

	fontSize: "1.2rem",
	fontStyle: "normal",
	fontWeight: 600,
	lineHeight: "166%",

	position: "absolute",
	top: 0,
	right: "-0.4rem",
	borderRadius: "50%"
})
